import React from 'react'
import { BsFillPatchCheckFill } from 'react-icons/bs'
import { HiBellAlert } from 'react-icons/hi2'
import { Services } from '../../../services'
import { semFoto } from '../../../assets/'
import RouterHook from '../../../contexts/RouterHook'
import moment from 'moment'

import './stylesCD.css'

export default function CompDiaria({ diaria, mode }) {
  const serverRouter = RouterHook()

  const day = new Date()
  const pago = diaria.valorRealizado === diaria.valorTotal

  function RetornaColorSttDiaria(stt) {
    switch (stt) {
      case 'SOLICITADA':
        return '#ff7043'
      case 'AGENDADA':
        return '#22ac4a'
      case 'CANCELADA':
        return '#bf3324'
      case 'REALIZADA':
        return '#00cda4'
    }
  }

  function FormaPay(status) {
    switch (status) {
      case 'PIX':
        return 'Pix'
      case 'CARTAO_CREDITO':
        return 'Cartão de Crédito'
      case 'DINHEIRO':
        return 'Dinheiro'
      case 'MAQUINA_CARTAO':
        return 'Máquina de Cartão'
      default:
        return status
    }
  }

  return (
    <>
      {mode ? (
        <button
          className='btt-comp-diaria'
          onClick={() => {
            serverRouter('diaria', diaria.idcompraDayuse)
          }}
        >
          <div className='contain-comp-diaria-super'>
            <div className='contain-comp-diaria-super-left'>
              <h3 className='title-comp-diaria'>{diaria.dayuse.titulo}</h3>
              <h3 className='rotul-diaria-data'>{moment(diaria.data).format('ddd, DD [de] MMM [de] YYYY')}</h3>
              <div className='contain-comp-diaria-infer'>
                <img
                  src={`${diaria.dayuse.empresa.urlFoto}${diaria.dayuse.empresa.foto}`}
                  alt='Centro esportivo'
                  onError={e => {
                    // setar a imagem padrão caso ocorra erro no carregamento
                    e.target.onerror = null // evita loop infinito
                    e.target.src = semFoto
                  }}
                />
                <h3 className='text-diaria-status-pay'>{diaria.dayuse.empresa.nome}</h3>
              </div>
            </div>
            <div className='contain-comp-diaria-super-rigth'>
              <h2 className='rotul-diaria-status' style={{ color: RetornaColorSttDiaria(diaria.status), marginTop: '3px' }}>
                {diaria.status}
              </h2>
              <h3>{`R$${diaria.valorTotal.toFixed(2).toString().replace('.', ',')}`}</h3>
              <h2 className='title-comp-diaria-pay'>{FormaPay(diaria.formaPagamento)}</h2>
            </div>
          </div>
        </button>
      ) : (
        <div className='contain-comp-diaria'>
          <div className='contain-comp-diaria-super'>
            <div className='contain-comp-diaria-super-left'>
              <h3 className='title-comp-diaria'>{diaria.titulo}</h3>
              <h3 className='rotul-diaria-data'>{`${Services.ReturnDay(day.getDay())}, ${Services.ReturnToStringDate(day)}`}</h3>
              <h4>Duração: {diaria.duracao}</h4>
              <h4>Valida para: {diaria.quadra}</h4>
              <h2 className='rotul-diaria-status' style={{ color: RetornaColorSttDiaria(diaria.status) }}>
                {diaria.status}
              </h2>
            </div>
            <div className='contain-comp-diaria-super-rigth'>
              <h2 className='title-comp-diaria'>{FormaPay(diaria.formaPagamento)}</h2>
              <h3>{`R$${diaria.valor.toFixed(2).toString().replace('.', ',')}`}</h3>
              {pago ? (
                <div className='contain-comp-diaria-line-payment' style={{ color: '#8FBC8F' }}>
                  <BsFillPatchCheckFill size={25} />
                  <h3 className='text-diaria-status-pay'>PAGO</h3>
                </div>
              ) : diaria.status !== 'CANCELADA' ? (
                <div className='contain-comp-diaria-line-payment' style={{ color: 'red' }}>
                  <HiBellAlert size={25} />
                  <h3 className='text-diaria-status-pay'>PENDENTE</h3>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
          {/*<div className = "contain-comp-diaria-infer">
            <img src = {`${diaria.empresa.urlFoto}${diaria.empresa.foto}`}/>
            <h3 className = "text-diaria-status-pay">{diaria.empresa.nome}</h3>
            </div>*/}
        </div>
      )}
    </>
  )
}
